import { render, staticRenderFns } from "./cancelRegistrationPage.vue?vue&type=template&id=bdd8862e&scoped=true"
import script from "./cancelRegistrationPage.vue?vue&type=script&lang=js"
export * from "./cancelRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./cancelRegistrationPage.vue?vue&type=style&index=0&id=bdd8862e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd8862e",
  null
  
)

export default component.exports